var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.43 1.15a1.1 1.1 0 0 1 .77 1.05v5.5h4.4a1.1 1.1 0 0 1 .901 1.73l-7.7 11A1.1 1.1 0 0 1 8.8 19.8v-5.5H4.4a1.1 1.1 0 0 1-.901-1.73l7.7-11a1.1 1.1 0 0 1 1.232-.42z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiz);
export default __webpack_public_path__ + "static/media/wiz.db403dce5370c38badffdfe7d442adf7.svg";
export { ForwardRef as ReactComponent };